<template>
  <div
    class="views-page is-flex is-flex-direction-column p-3 pb-5"
    style="min-height: 50vh"
  >
    <div
      class="info-line"
      :class="GetMessagesData.main_color"
    />
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      :can-cancel="false"
    />
    <div class="is-flex is-flex-direction-column" style="gap: 1rem">
      <h2 class="is-size-5 has-text-weight-semibold mb-3 is-flex is-align-items-center is-justify-content-space-between">
        {{ GetMessagesData.device_name }} | Журнал ТО
        <button
          v-if="isManager"
          class="button is-info is-small"
          @click="openCreateModal"
        >Добавить событие</button>
      </h2>
      <p v-if="!isLoading && comments.length === 0" class="has-text-centered has-text-grey">Нет данных</p>
      <DeviceComment
        v-for="comment in comments"
        :key="comment.id"
        :author="getAuthorFullName(comment.user)"
        :title="comment.title"
        :text="comment.text"
        :date="comment.date"
        :is-owner="isOwner(comment.user.id)"
        @edit="onCommentEdit(comment)"
        @delete="onCommentDelete(comment.id)"
      />
      <b-pagination
        v-model="currentPage"
        :total="commentCount"
        :per-page="5"
        order="is-centered"
        icon-pack="fas"
        @change="getComments"
      >
        <template #previous="props">
          <b-pagination-button
            :page="props.page"
            @click="getComments(currentPage-1)"
          >
            <font-awesome-icon :icon="['fas', 'fa-chevron-left']" />
          </b-pagination-button>
        </template>
        <template #next="props">
          <b-pagination-button
            :page="props.page"
            @click="getComments(currentPage+1)"
          >
            <font-awesome-icon :icon="['fas', 'fa-chevron-right']" />
          </b-pagination-button>
        </template>
      </b-pagination>
    </div>
    <DeviceCommentSaveModal
      :device-id="device_id"
      :is-modal-active.sync="isModalActive"
      :editing-comment.sync="editingComment"
      @refresh="getComments"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex"
import DeviceComment from "@/components/DeviceComment/DeviceComment.vue"
import DeviceCommentSaveModal from "@/components/DeviceComment/DeviceCommentSaveModal.vue"

export default {
  components: { DeviceCommentSaveModal, DeviceComment },
  props: ["device_id"],
  data() {
    return {
      currentPage: 1,
      comments: [],
      commentCount: 0,
      isLoading: true,
      isModalActive: false,
      editingComment: null
    }
  },
  computed: {
    ...mapGetters(["GetMessagesData", "getUser"]),
    isManager() {
      return this.getUser?.role_id === 3
    }
  },
  created() {
    // this.ChangeNavName("Архивные сообщения")
    this.FetchMessages(this.device_id)
    this.getComments()
  },
  methods: {
    ...mapActions(["FetchArchiveMsg", "FetchMessages"]),
    ...mapMutations(["ChangeNavName"]),

    async getComments(page) {
      this.currentPage = page || 1;
      this.isLoading = true
      try {
        const { data } = await this.$axios.get(`user/agents/${this.device_id}/commentaries/paginate/${(this.currentPage - 1) * 5}/5`)
        this.comments = data?.data || []
        this.commentCount = data?.count ?? 0
      } catch (e) {
        this.isLoading = false
        throw new Error(e)
      }
      this.isLoading = false
    },
    getAuthorFullName(user) {
      return (user.last_name ?? '') + " " + (user.first_name ?? '')
    },
    isOwner(userId) {
      return userId === this.getUser?.id
    },
    openCreateModal() {
      this.editingComment = null
      this.isModalActive = true
    },
    onCommentEdit(comment) {
      this.editingComment = comment
      this.isModalActive = true
    },
    async deleteComment(commentId) {
      try {
        await this.$axios.delete(`user/commentaries/${commentId}`)
        await this.getComments()
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    onCommentDelete(commentId) {
      this.$buefy.dialog.confirm({
        title: 'Подтвердите удаление',
        message: 'Вы уверены, что хотите удалить этот журнал? Это действие необратимо.',
        confirmText: 'Да, удалить',
        cancelText: 'Отмена',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteComment(commentId)
        }
      })
    },
  },
}
</script>

